<div class="content">
  <glxy-label class="info-message">{{ 'AUTOMATIONS.EDITOR.TASKS.UPDATE_OPPORTUNITY.INFO' | translate }}</glxy-label>
  @if (components$ | async; as components) {
    <div class="inputs">
      @if (showPipelineSelector()) {
        <div>
          <button class="close-pipeline-button" mat-icon-button (click)="removePipelineFields()">
            <mat-icon>close</mat-icon>
          </button>
          <automata-crm-pipeline-selector
            #crmPipelineSelector
            [required]="true"
            [initialValue]="initialStageId || initialStageId ? [initialPipelineId, initialStageId] : []"
            [defaultStageSelection]="FIRST_STAGE"
          ></automata-crm-pipeline-selector>
        </div>
      }
      @for (formControl of formArray.controls; track formControl; let idx = $index) {
        @if (!fieldIsOverridden(formControl.value?.fieldId)) {
          <automata-data-entry
            [dataEntryOptions]="components"
            [formControl]="formControl"
            (remove)="removeDataEntryComponent(idx)"
          ></automata-data-entry>
        }
      }
    </div>
  }
  <div>
    <button mat-button color="primary" (click)="addDataEntryComponent()">
      {{ 'AUTOMATIONS.EDITOR.TASKS.UPDATE_OPPORTUNITY.ADD_ADDITIONAL_FIELDS' | translate }}
    </button>
  </div>
</div>
